export default __webpack_public_path__ + "static/media/loading.5cf12827.svg";